import { Component } from '@headless-workspace/typings';
import { GlowFieldWrapper, GlowFieldWrapperProps } from '../../atoms';
import { StarRating, StarRatingProps } from './StarRating';

type GlowStarRatingProps = StarRatingProps & Omit<GlowFieldWrapperProps, 'children'>;

export const GlowStarRating: Component<GlowStarRatingProps> = ({
    defaultValue,
    fieldId,
    required,
    errorText,
    label,
    id,
    name,
    onChange,
    value,
}) => {
    return (
        <GlowFieldWrapper className={'block'} fieldId={fieldId} required={required} errorText={errorText} value={value}>
            {() => (
                <StarRating
                    label={label}
                    id={id}
                    name={name}
                    onChange={onChange}
                    className={'justify-between'}
                    defaultValue={defaultValue}
                />
            )}
        </GlowFieldWrapper>
    );
};
